import React, {Component} from 'react';
import {connect} from 'react-redux';
import {LazyLoadImage} from "react-lazy-load-image-component";

class Input extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleChange(event) {
        if (this.props.configInput.type === "checkbox") {
            this.props.configInput.methodChange(event.target.checked, event.target.id);
        } else {
            this.props.configInput.methodChange(event.target.value, event.target.id);
        }
    }

    handleBlur(event) {
        if (this.props.configInput.hasOwnProperty("blurMethod")) {
            this.props.configInput.blurMethod(this.props.configInput.id);
        }
    }

    render() {
        let formControl = "form-control " + this.props.configInput.controlValidate;
        let iconSpan = "" + this.props.configInput.iconSpan;
        let formGroup = "form-group";
        if (this.props.configInput.type === "checkbox") {
            formGroup = formGroup + " " + this.props.configInput.formGroup;
        }
        let imgClass = this.props.configInput.imgClass + " form-inline-img";

        return (
            <div className={this.props.configInput.columns}>
                <div className={formGroup}>
                    {this.props.configInput.title && <span>{this.props.configInput.title}</span>}
                    {this.props.configInput.type !== "checkbox" &&
                    <div className={this.props.configInput.inlineIcon}>
                        <input id={this.props.configInput.id} name={this.props.configInput.id}
                               type={this.props.configInput.type} className={formControl}
                               placeholder={this.props.configInput.placeHolder} onChange={this.handleChange}
                               onBlur={this.handleBlur}/>
                        {/*<span className={iconSpan}></span>*/}
                        {(this.props.configInput.imgUrl) ? <LazyLoadImage threshold={150} className={imgClass}
                                                                src={this.props.configInput.imgUrl}/> :
                            <span className={iconSpan}></span>}
                    </div>
                    }
                    {this.props.configInput.type === "checkbox" &&
                    <label className={this.props.configInput.labelClass}>
                        <input id={this.props.configInput.id} name={this.props.configInput.id} type={this.props.configInput.type} className={formControl} onChange={this.handleChange}/>
                        <span className={iconSpan}></span>
                        {/*<span className={this.props.configInput.indicator}></span>*/}
                        <span className={this.props.configInput.descriptionClass}>{this.props.configInput.labelDescription}</span>
                    </label>
                    }
                </div>
            </div>
        );
    }

    componentDidMount() {
        let element = $("#" + this.props.configInput.id);
        if (this.props.configInput.hasOwnProperty("readOnly")) {
            element.attr('readonly', this.props.configInput.readOnly);
        }

        if (this.props.configInput.hasOwnProperty("maxlength")) {
            element.attr('maxlength', this.props.configInput.maxlength);
        }

        if (this.props.configInput.hasOwnProperty("numericKeyPress")) {
            $("#" + this.props.configInput.id).on("keypress keyup", (event) => {
                let element = $(event.currentTarget);
                element.val(element.val().replace(/[^\d].+/, ""));
                if ((event.which < 48 || event.which > 57)) {
                    event.preventDefault();
                }
            })
        }
        if (this.props.hasOwnProperty("initialText")) {
            element.val(this.props.initialText);
        }
        if(this.props.configInput.type === "checkbox"){
            element.prop('checked', this.props.initialText);
        }
    }

    componentDidUpdate() {
        let element = $("#" + this.props.configInput.id);
        if (this.props.hasOwnProperty("initialText")) {
            element.val(this.props.initialText);
        }

    }

}

export default Input
